import template from 'text!./templates/effective-date.html';

export default [function () {
    return {
        'scope': {
            'model': '=',
            'mode': '=',
            'minDate': '=',
            'maxDate': '=',
            'onNext': '&',
            'wizardState': '@'
        },
        template: template,
        controller: function controller($scope) {
            $scope.editableStates = ['PolicyList', 'EffectiveDate', 'WhatsNext'];
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/endorsement/common/directives/EffectiveDate.js
// module id = 1444
// module chunks = 0